var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 133 134",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.684 41.495-7.96 4.2913-8.3254-4.2913v-5.1462h16.285v5.1462z",
    fill: "#00C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m63.473 93.556h17.057v-36.289l4.3163 2.4901 6.1838-10.583-11.82-8.5909c-0.6475-0.3818-1.3447-0.7802-1.6601-0.913-2.1509-0.8085-4.4187-1.2626-6.715-1.3447-0.274 1.6103-1.8676 7.4704-7.3708 7.4704s-7.0969-5.8103-7.3708-7.4704c-2.2935 0.083-4.5585 0.5371-6.7067 1.3447-0.2988 0.1328-0.9961 0.5312-1.6601 0.913l-11.812 8.5909 6.1838 10.616 4.3162-2.4901v36.256h17.057z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m55.372 36.349 8.1676 9.4375-4.4158 4.034-5.6941-11.214 1.9423-2.2577z",
    fill: "#CCEFDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m71.715 36.349-8.1759 9.4375 4.4241 4.034 5.6941-11.214-1.9423-2.2577z",
    fill: "#CCEFDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m65.025 45.545h-2.9799v11.214h2.9799v-11.214z",
    fill: "#CCEFDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44.598 58.346-2.4984 1.4443-6.1838-10.616 2.3822-1.7348 6.3 10.907z",
    fill: "#CCEFDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m82.348 58.346 2.4984 1.4443 6.1838-10.616-2.3822-1.7348-6.3 10.907z",
    fill: "#CCEFDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m80.539 91.298h-34.123v2.2494h34.123v-2.2494z",
    fill: "#CCEFDB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.373,
    y: 36.349,
    width: 16.336,
    height: 2.7997,
    fill: "#CCEFDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m88.088 84.133 6.9602-1.7367-7.0635-1.7077-1.725-6.7534-1.6652 6.7667-7.0568 1.763 6.9805 1.6821 1.8094 7.1157 1.7604-7.1297z",
    fill: "#FFB762"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m50.539 49.831 3.8787-0.9176-3.9358-0.8974-0.9596-3.5691-0.9259 3.5765-3.9343 0.9282 3.8858 0.8872 1.0103 3.7567 0.9808-3.7645z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "effect1_dropShadow_5137_18950"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_18950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_18950",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c1a4f253a50892869af66c66f49a0359.svg";
export { ForwardRef as ReactComponent };